module.exports = "/images/bank.svg?ef8f17184f42298775c30f022593cc41";